import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconLabelComponent } from './icon-label.component';

@NgModule({
    imports: [CommonModule],
    declarations: [IconLabelComponent],
    entryComponents: [IconLabelComponent],
    exports: [IconLabelComponent]
})
export class IconLabelModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/icon-label/icon-label.module.ts